import React from 'react'

import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'

const form = props => {
  const form = Object.entries(props.form).map(item => {
    let [formKey, formAttrs] = item
    return (
      <InputGroup
        key={formKey}
        label={formAttrs.label}
        inputType={formAttrs.elementType}
        configs={formAttrs.elementConfig}
        invalid={!formAttrs.valid}
        validations={formAttrs.validation}
        touched={formAttrs.touched}
        changed={e => props.inputChanged(formKey, e)}
        inputValue={formAttrs.value}
        validationError={formAttrs.error}
      />
    )
  })

  return <div className={classes.Form}>{form}</div>
}

export default form
